var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletIllustrated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 4,
    fill: "#53CAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34 46C33.4752 46.5261 32.8517 46.9435 32.1654 47.2283C31.479 47.5131 30.7432 47.6597 30 47.6597C29.2569 47.6597 28.5211 47.5131 27.8347 47.2283C27.1483 46.9435 26.5249 46.5261 26 46C25.4739 45.4752 25.0565 44.8517 24.7717 44.1653C24.4869 43.4789 24.3403 42.7431 24.3403 42C24.3403 41.2569 24.4869 40.5211 24.7717 39.8347C25.0565 39.1483 25.4739 38.5248 26 38L32 32L40 40L34 46Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25.9944L26.0057 37.9887C23.7944 40.2 23.7926 43.7835 26.0017 45.9927C28.2109 48.2018 31.7944 48.2001 34.0057 45.9887L46 33.9944C48.2114 31.7831 48.2132 28.1996 46.004 25.9904C43.7949 23.7813 40.2113 23.783 38 25.9944Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32L40 40",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0125 34.0125L43.0625 31.0625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIllustrated);
export default __webpack_public_path__ + "static/media/tablet-illustrated.91a53664fc816a997461b8922bab7638.svg";
export { ForwardRef as ReactComponent };